import { parseWorkspaceRoute } from "@/utils/workspaceRoutes"

export function getCoviWorkspaceRelativeRoute(
  pathname: string,
  organizationSlug: string | null,
): string | null {
  const parsed = parseWorkspaceRoute(pathname)
  return parsed?.organizationSlug === organizationSlug
    ? parsed.relativePath
    : null
}

export function getCoviViewRoute(
  pathname: string,
  organizationSlug: string | null,
  maxLength: number,
): string {
  const workspaceRoute = getCoviWorkspaceRelativeRoute(
    pathname,
    organizationSlug,
  )
  if (workspaceRoute) {
    return clip(workspaceRoute, maxLength)
  }
  if (organizationSlug) {
    const prefix = `/${organizationSlug}`
    if (pathname === prefix) {
      return "/"
    }
    if (pathname.startsWith(`${prefix}/`)) {
      return clip(pathname.slice(prefix.length), maxLength)
    }
  }
  return clip(pathname, maxLength)
}

function clip(value: string, maxLength: number): string {
  return value.length > maxLength ? value.slice(0, maxLength) : value
}
